// extracted by mini-css-extract-plugin
export default {"kitoMascot":"styles_kitoMascot__Vrf1s"};